import { connect } from 'react-redux'
import CheckoutConfirm from './CheckoutConfirm'
import { getCheckoutContactActionRequest } from 'store/actions'

const mapStateToProps = state => ({
  color: '#d80417',
  lang: state.changeLang.lang
})

const mapDispatchToProps = dispatch => ({
  getCheckoutContactActionRequest: body =>
    dispatch(getCheckoutContactActionRequest(body))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckoutConfirm)
